import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Grid, Paper, Typography, Box, Card,
    Tooltip, FormControl, InputLabel, Select, MenuItem,
    IconButton, Popover
} from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import axios from '../../../axios-order'
import '../../Dashboards/./sales/ageingSummary/dashboard.css'
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ValidatorForm } from "react-material-ui-form-validator";
import DatePicker from "../../../components/ui/DatePicker";
import moment from "moment";
import PieChart from '../PieChart'
import { ResponsiveContainer } from 'recharts';
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import GrainOutlinedIcon from '@mui/icons-material/GrainOutlined';
import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { canWrite } from '../../../utils/privilegeUtils'

const currentDate = new Date();
const todayDate = `${currentDate.getFullYear()}-${('0' + (currentDate.getMonth() + 1)).slice(-2)}-${('0' + currentDate.getDate()).slice(-2)}`

const C2CReport = () => {
    let history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false)
    const [selectedEntity, setSelectedEntity] = useState(localStorage.getItem("business_entity_id"))
    const [displyAsOFDate, setDisplayAsOfDate] = useState(todayDate)
    const [selectedAsOfDate, setSelectedAsOfDate] = useState(todayDate);
    const [exportButtonLaoding, setExportButtonLaoding] = useState(false)
    const [entityData, setEntityData] = useState([])
    const [haveMultiEntity, setHaveMultiEntity] = useState(false)
    const [c2cDashboardCardsData, setC2cDashboardCardsData] = useState({});
    const [overDueDataSales, setOverDueDataSales] = useState([])
    const [overDueDataPurchses, setOverDueDataPurchses] = useState([])
    const [c2cCardsData, setC2CCardsData] = useState({});
    const [gstr1AmountNotCollectedData, setGstr1AmountNotCollectedData] = useState([])
    const [gstUsageDashBoardData, setGstUsageDashBoardData] = useState([])
    const [tdsAmountNotReflectedIn26ASData, setTdsAmountNotReflectedIn26ASData] = useState([])
    const [gst3BInputNotFiledAndNotReflected, setGSTR3BInputNotFiledAndNotReflected] = useState([])
    const [selectedDateFilter, setSelectedDateFilter] = useState('as_of_date');
    const [customFromDate, setCustomFromDate] = useState('');
    const [customToDate, setCustomToDate] = useState('');
    // Add these new state variables (around line 50)
    const [displayCustomFromDate, setDisplayCustomFromDate] = useState('');
    const [displayCustomToDate, setDisplayCustomToDate] = useState('');
    const handleBack = () => {
        history.push('/reportCards');
    };

    // Update useEffect (around line 65)
    useEffect(() => {
        if (selectedDateFilter === 'as_of_date' && selectedAsOfDate && moment(selectedAsOfDate, "YYYY-MM-DD", true).isValid()) {
            getC2cAnalayticsData()
        } else if (selectedDateFilter === 'custom_date' && customFromDate && customToDate &&
            moment(customFromDate, "YYYY-MM-DD", true).isValid() &&
            moment(customToDate, "YYYY-MM-DD", true).isValid()) {
            getC2cAnalayticsData()
        }
    }, [selectedAsOfDate, selectedEntity, selectedDateFilter, customFromDate, customToDate])

    // Add these handler functions (around line 120)
    const onCustomFromDateChange = (v) => {
        setDisplayCustomFromDate(v)
        const date = moment(v).format("YYYY-MM-DD")
        setCustomFromDate(date)
    }

    const onCustomToDateChange = (v) => {
        setDisplayCustomToDate(v)
        const date = moment(v).format("YYYY-MM-DD")
        setCustomToDate(date)
    }

    const handleDateFilterChange = (filterType) => {
        setSelectedDateFilter(filterType);
        if (filterType === 'as_of_date' && !selectedAsOfDate) {
            setSelectedAsOfDate(todayDate);
            setDisplayAsOfDate(todayDate);
        }
    }

    const getC2cAnalayticsData = () => {
        setLoading(true)
        const payLoadData = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "org_gstin": localStorage.getItem('gst'),
            "excel_report": false,
            "card_data": false
        }
        // Add conditional fields based on selected filter
        if (selectedDateFilter === 'as_of_date') {
            payLoadData.as_of_date = selectedAsOfDate;
        } else if (selectedDateFilter === 'custom_date') {
            payLoadData.from_date = customFromDate;
            payLoadData.to_date = customToDate;
        }
        axios.post('/get_c2c_records_new', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    const dashboardCardsData = res?.data?.records?.c2c_main_cards_data;
                    const c2cCardsData = res?.data?.records?.c2c_cards_data;
                    const ageingSalesArray = res?.data?.records?.ageing_data?.sales
                    const ageingPurchsesArray = res?.data?.records?.ageing_data?.purchase
                    const gstr1AmountNotCollectedRecords = res?.data?.records?.gstr1_amount_not_collected_data
                    const tdsAmountNotReflected = res?.data?.records?.tds_amount_not_reflected_in_26as
                    const gstUsageDashBoardData = res?.data?.records?.gst_usage_dashboard
                    const gstr3BNotFiledNotReflected = res?.data?.records?.not_filed_and_input_not_reflected
                    if (dashboardCardsData) {
                        setC2cDashboardCardsData(dashboardCardsData)
                    }
                    if (ageingSalesArray) {
                        setOverDueDataSales(ageingSalesArray)
                    }
                    if (ageingPurchsesArray) {
                        setOverDueDataPurchses(ageingPurchsesArray)
                    }
                    if (c2cCardsData) {
                        setC2CCardsData(c2cCardsData)
                    }
                    if (gstr1AmountNotCollectedRecords) {
                        setGstr1AmountNotCollectedData(gstr1AmountNotCollectedRecords)
                    }
                    if (tdsAmountNotReflected) {
                        setTdsAmountNotReflectedIn26ASData(tdsAmountNotReflected)
                    }
                    if (gstUsageDashBoardData) {
                        setGstUsageDashBoardData(gstUsageDashBoardData)
                    } if (gstr3BNotFiledNotReflected) {
                        setGSTR3BInputNotFiledAndNotReflected(gstr3BNotFiledNotReflected)
                    }

                }
            }).catch((err) => {

            }).finally(() => {
                setLoading(false)
            })
    }

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleExportExcel = () => {
        setExportButtonLaoding(true)
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = 'C2C Report.xlsx'
        const payLoadData = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "org_gstin": localStorage.getItem('gst'),
            "as_of_date": selectedAsOfDate,
            "excel_report": true,
            "card_data": false,
            "ageing_type": 'receivable'
        }
        axios
            .post(`/get_c2c_records_new`, payLoadData)
            .then((res) => {
                if (res?.data?.file) {
                    downloadBase64File(contentType, res?.data?.file, filename);
                }

            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setExportButtonLaoding(false)
            });
    }

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const onDateChnageHandler = (v) => {
        setDisplayAsOfDate(v)
        const date = moment(v).format("YYYY-MM-DD")
        setSelectedAsOfDate(date)
    }

    const formatToINR = (value) => {
        if (!value || value == null || value === '') return '₹0';
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const renderC2CAnalyticsCards = () => {
        if (!c2cDashboardCardsData || Object.keys(c2cDashboardCardsData).length === 0) {
            return null;
        }
        const iconComponents = {
            "DSO": <AccountBalanceIcon sx={{ color: 'white' }} />,
            "DPO": <LeaderboardIcon sx={{ color: 'white' }} />,
            "C2C": <CurrencyRupeeIcon sx={{ color: 'white' }} />,
        };

        const iconStyles = [
            { backgroundColor: '#3b82f6' },
            { backgroundColor: '#22c55e' },
            { backgroundColor: '#f97316' },
        ];

        return (
            <Grid
                container
                direction="row"
                spacing={6}
                justifyContent="center"
                sx={{ padding: 2 }}
            >
                {Object.keys(c2cDashboardCardsData).map((key, index) => (
                    <Grid item key={index}>
                        <Card
                            sx={{
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                                borderRadius: 4,
                                padding: 3,
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: 260,
                                height: 130,
                                backdropFilter: 'blur(8px)',
                                background: 'rgba(255, 255, 255, 0.8)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                transition: 'all 0.3s ease',
                                overflow: 'hidden',
                                '&:hover': {
                                    transform: 'scale(1.03)',
                                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 15,
                                    right: 15,
                                    backgroundColor: iconStyles[index]?.backgroundColor,
                                    width: 42,
                                    height: 42,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: 2,
                                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                                }}
                            >
                                {iconComponents[key]}
                            </Box>

                            <Box sx={{ textAlign: 'center', marginTop: 1 }}>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#111827",
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.8,
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                >
                                    {key}
                                </Typography>

                                <Typography
                                    variant="h4"
                                    sx={{
                                        marginTop: 1,
                                        color: '#1f2937',
                                        fontWeight: 700,
                                        fontFamily: "'Poppins', sans-serif",
                                        background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 100%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                    }}
                                >
                                    {(c2cDashboardCardsData[key])}
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    };

    const renderAdditionalCards = () => {
        if (!c2cCardsData || Object.keys(c2cCardsData).length === 0) {
            return null;
        }
        const additionalData = {
            "Ageing Receivable": { value: c2cCardsData['ageing_receivable_tax_non_tax'], icon: <AccountBalanceIcon sx={{ color: 'white' }} /> },
            "Ageing Payable": { value: c2cCardsData['ageing_payable_tax_non_tax'], icon: <CreditCardIcon sx={{ color: 'white' }} /> },
            "GST Payable": { value: c2cCardsData['gst_payable'], icon: <ReceiptIcon sx={{ color: 'white' }} /> },
            "Input Reversed": { value: c2cCardsData['input_reversed'], icon: <AutorenewIcon sx={{ color: 'white' }} /> },
            "Ageing Receivable > 365": { value: c2cCardsData['sales_outstanding_more_than_one_year'], icon: <AccountBalanceIcon sx={{ color: 'white', fontSize: '1.3rem' }} />, isRed: true },
            "Ageing Payable > 365": { value: c2cCardsData['purchase_outstanding_more_than_one_year'], icon: <CreditCardIcon sx={{ color: 'white', fontSize: '1.3rem' }} />, isRed: true },
            "Input Not Reflected": { value: c2cCardsData['input_not_reflected'], icon: <VisibilityOffIcon sx={{ color: 'white' }} /> },
            "TDS Not in 26AS": { value: c2cCardsData['tds_amount_not_reflected_in_26AS'], icon: <MoneyOffIcon sx={{ color: 'white' }} /> },
            "RCM Payment": { value: c2cCardsData['rcm_payament'], icon: <SyncAltIcon sx={{ color: 'white' }} /> },
            "Net Cash Flow": { value: c2cCardsData['net_cash_flow'], icon: <AttachMoneyIcon sx={{ color: 'white' }} /> },
        };

        const iconColors = ['#6366f1', '#f43f5e', '#14b8a6', '#f97316', '#8b5cf6', '#ef4444', '#3b82f6', '#22c55e'];

        return (
            <Grid container spacing={6} justifyContent="center" sx={{ padding: 2 }}>
                {Object.keys(additionalData).map((key, index) => {
                    const isRedCard = additionalData[key].isRed;

                    return (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card
                                sx={{
                                    boxShadow: isRedCard ? '0 4px 20px rgba(239, 68, 68, 0.3)' : '0 4px 20px rgba(0, 0, 0, 0.1)',
                                    borderRadius: 4,
                                    padding: 3,
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    background: isRedCard ? 'linear-gradient(135deg, #fee2e2 0%, #fca5a5 100%)' : 'linear-gradient(135deg, #ffffff 0%, #e3e3e3 100%)',
                                    border: isRedCard ? '2px solid #ef4444' : '1px solid rgba(255, 255, 255, 0.1)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.03)',
                                        boxShadow: isRedCard ? '0 8px 30px rgba(239, 68, 68, 0.4)' : '0 8px 30px rgba(0, 0, 0, 0.15)',
                                    },
                                }}
                            >
                                <Box sx={{
                                    position: 'absolute',
                                    top: 15,
                                    right: 15,
                                    backgroundColor: isRedCard ? '#dc2626' : iconColors[index % iconColors.length],
                                    width: isRedCard ? 36 : 42,
                                    height: isRedCard ? 36 : 42,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    boxShadow: isRedCard ? '0 4px 10px rgba(220, 38, 38, 0.4)' : '0 4px 10px rgba(0,0,0,0.1)'
                                }}>
                                    {additionalData[key].icon}
                                </Box>
                                <Typography variant="h7" sx={{ fontWeight: 600, color: isRedCard ? "#7f1d1d" : "#1e293b", textTransform: 'capitalize', fontFamily: "'Poppins', sans-serif" }}>{key}</Typography>
                                <Typography variant="h6" sx={{ marginTop: 1, fontWeight: 700, color: isRedCard ? '#991b1b' : 'inherit' }}>{formatToINR(additionalData[key].value)}</Typography>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    const renderGstr1AmountNotCollectedReport = () => {
        if (!gstr1AmountNotCollectedData || !gstr1AmountNotCollectedData?.length) {
            return <></>;
        }
        const chartData = gstr1AmountNotCollectedData.map(item => ({
            name: item.gst_amount_collection_status_2,
            y: item.outstanding_amount,
        }));

        const options = {
            chart: {
                type: 'column',
                borderRadius: 15,
                spacingBottom: 30,
            },
            title: {
                text: 'GSTR-1 Amount Not Collected from Customer',
                style: {
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#2C3E50',
                },
            },
            subtitle: {
                text: 'Visualizing the GSTR-1 Amount not collected from customer',
                style: {
                    fontSize: '14px',
                    color: '#5D6D7E',

                },
            },
            tooltip: {
                backgroundColor: '#2E4053',
                borderColor: '#5499C7',
                borderRadius: 8,
                style: {
                    color: '#fff',
                    fontSize: '14px',
                },
                pointFormat: '{point.name}: <b>{point.y}</b>',
                formatter: function () {
                    return `${this.point.name}: <b>${formatToINR(this.point.y)}</b>`;
                },
            },
            xAxis: {
                categories: chartData.map((item) => item.name),
                labels: {
                    style: {
                        color: '#4A6274',
                        fontSize: '13px',
                        fontWeight: 'bold',
                    },
                },
                lineColor: '#D4E6F1',
                tickColor: '#D4E6F1',
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Amount (INR)',
                },
                labels: {
                    formatter: function () {
                        return formatToINR(this.value);
                    },
                    style: {
                        color: '#4A6274',
                    },
                },
                gridLineWidth: 0,
                gridLineColor: '#D4E6F1',
            },
            plotOptions: {
                column: {
                    cursor: 'pointer',
                    pointWidth: 45,
                    borderRadius: 4,
                    borderWidth: 1,
                    color: {
                        linearGradient: [0, 0, 0, 500],
                        stops: [
                            [0, '#1B4F72'],
                            [0.5, '#5499C7'],
                            [1, '#AED6F1'],
                        ],
                    },
                    shadow: true,
                    groupPadding: 0.1,
                    pointPadding: 0.2,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return formatToINR(this.y); // Format in INR
                        },
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#2C3E50',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                        },
                    },
                },
            },
            series: [
                {
                    name: 'Outstanding Amount',
                    data: chartData.map((item) => ({
                        name: item.name,
                        y: item.y,
                    })),
                    color: {
                        linearGradient: [0, 0, 0, 500],
                        stops: [
                            [0, '#1B4F72'],
                            [0.5, '#5499C7'],
                            [1, '#AED6F1'],
                        ],
                    },
                    borderRadius: 8,
                    borderWidth: 1,
                },
            ],
            exporting: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            legend: {
                itemStyle: {
                    color: '#2C3E50',
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
            },
        };

        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    padding: '16px',
                    borderRadius: '8px',
                }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    };

    const renderGstUsageStackedChart = () => {
        if (!gstUsageDashBoardData || !gstUsageDashBoardData?.value?.length) {
            return <></>;
        }

        const { categories, value } = gstUsageDashBoardData;

        const options = {
            chart: {
                type: 'column',
                borderRadius: 15,
                spacingBottom: 30,
                height: 500,
                // width: 900,
            },
            title: {
                text: 'GST Usage Breakdown',
                style: {
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#2C3E50',
                    textTransform: 'uppercase',
                },
            },
            subtitle: {
                text: 'Visualizing GST distribution across different categories',
                style: {
                    fontSize: '14px',
                    color: '#5D6D7E',
                },
            },
            xAxis: {
                categories,
                title: {
                    text: 'GST Categories',
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#2C3E50',
                    },
                },
                labels: {
                    style: {
                        color: '#4A6274',
                        fontSize: '13px',
                        fontWeight: 'bold',
                    },
                },
                lineColor: '#D4E6F1',
                tickColor: '#D4E6F1',
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Amount (INR)',
                },
                labels: {
                    formatter: function () {
                        return formatToINR(this.value);
                    },
                    style: {
                        color: '#4A6274',
                    },
                },
                gridLineWidth: 0, // Remove grid lines
            },
            tooltip: {
                shared: true,
                backgroundColor: '#2E4053',
                borderColor: '#5499C7',
                borderRadius: 8,
                style: {
                    color: '#fff',
                    fontSize: '14px',
                },
                formatter: function () {
                    let tooltip = `<b>${this.x}</b><br/>`;
                    this.points.forEach(point => {
                        tooltip += `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${formatToINR(point.y)}</b><br/>`;
                    });
                    return tooltip;
                },
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    borderRadius: 4,
                    borderWidth: 1,
                    shadow: true,
                    minPointLength: 28,
                    pointWidth: 120,
                    groupPadding: 0.2,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return formatToINR(this.y);
                        },
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#2C3E50',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
                        },
                    },
                },
            },
            series: value.map((item, index) => ({
                name: item.name,
                data: item.data,
                // color: ['#1B4F72', '#5499C7', '#AED6F1', '#FFC300'][index], // Cool color palette
            })),
            exporting: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            legend: {
                itemStyle: {
                    color: '#2C3E50',
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
            },
        };

        return (
            <div style={{ width: '100%', height: '100%', padding: '16px', borderRadius: '8px' }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    };

    const renderTdsAmountNotReflectedReport = () => {
        if (!tdsAmountNotReflectedIn26ASData || !tdsAmountNotReflectedIn26ASData.length) {
            return <></>;
        }

        const chartData = tdsAmountNotReflectedIn26ASData.map(item => ({
            name: item.financial_year,
            y: item.amount_paid,
        }));

        const options = {
            chart: {
                type: 'column',
                borderRadius: 15,
                spacingBottom: 30,
                backgroundColor: '#FFFFFF',
            },
            title: {
                text: 'TDS Amount Not Reflected in 26AS',
                style: {
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#2C3E50',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
                },
            },
            subtitle: {
                text: 'Visualizing the TDS Amount Not Reflected in 26AS',
                style: {
                    fontSize: '14px',
                    color: '#5D6D7E',
                },
            },
            tooltip: {
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderColor: '#6C5CE7',
                borderRadius: 8,
                shadow: true,
                style: {
                    color: '#2C3E50',
                    fontSize: '14px',
                },
                formatter: function () {
                    return `<b style="color:#00B8D4">${this.point.name}:</b> <b>${formatToINR(this.point.y)}</b>`;
                },
            },
            xAxis: {
                categories: chartData.map(item => item.name),
                labels: {
                    style: {
                        color: '#34495E', // Dark Gray
                        fontSize: '14px',
                        fontWeight: 'bold',
                    },
                },
                lineColor: '#B3C0C8',
                tickColor: '#B3C0C8',
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Amount (INR)',
                    style: {
                        color: '#5D6D7E',
                    },
                },
                labels: {
                    formatter: function () {
                        return formatToINR(this.value);
                    },
                    style: {
                        color: '#5D6D7E',
                    },
                },
                gridLineWidth: 0,
                gridLineColor: '#D0D3D4',
            },
            plotOptions: {
                column: {
                    cursor: 'pointer',
                    pointWidth: 45,
                    borderRadius: 4,
                    borderWidth: 1,
                    borderColor: '#1B9CFC', // Electric blue
                    color: {
                        linearGradient: [0, 0, 0, 500],
                        stops: [
                            [0, '#6C5CE7'],  // Neon Purple
                            [0.5, '#3F51B5'], // Deep Blue
                            [1, '#00B8D4'],  // Aqua Glow
                        ],
                    },
                    shadow: {
                        color: 'rgba(0, 184, 212, 0.5)',
                        offsetX: 0,
                        offsetY: 4,
                        opacity: 0.7,
                    },
                    groupPadding: 0.1,
                    pointPadding: 0.2,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            return formatToINR(this.y);
                        },
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#2C3E50',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                        },
                    },
                },
            },
            series: [
                {
                    name: 'TDS Amount',
                    data: chartData.map(item => ({
                        name: item.name,
                        y: item.y,
                    })),
                    color: {
                        linearGradient: [0, 0, 0, 500],
                        stops: [
                            [0, '#6C5CE7'],  // Neon Purple
                            [0.5, '#3F51B5'], // Deep Blue
                            [1, '#00B8D4'],  // Aqua Glow
                        ],
                    },
                    borderRadius: 8,
                    borderWidth: 1,
                },
            ],
            exporting: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            legend: {
                itemStyle: {
                    color: '#2C3E50',
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
            },
        };

        return (
            <div style={{ width: '100%', height: '100%', padding: '16px', borderRadius: '8px' }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    };

    const renderEmptyState = () => {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                spacing={2}
                style={{
                    height: '60vh', // Ensure it takes up most of the screen height
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'center',
                }}
            >
                <GrainOutlinedIcon style={{ fontSize: '6rem', color: '#ff1744' }} />
                <Typography
                    variant="h6"
                    style={{
                        fontWeight: '500',
                        color: '#333333',
                        fontFamily: '"Georgia", "Times New Roman", "Times", serif',
                        lineHeight: 1.5,
                        marginTop: '16px',
                        maxWidth: '400px',
                        padding: '0 16px',
                    }}
                >
                    No C2C data available. Please generate the C2C Report to view the data and gain insights.
                </Typography>
            </Grid>
        );
    };



    return (
        <div>
            {/* <div style={{ marginBottom: '16px' }}>
                <button
                    className="button-outlined-primary"
                    style={{ marginLeft: "0px", width: "auto", marginTop: "1px", padding: "6px 16px" }}
                    onClick={handleBack}
                >
                    BACK
                </button>
            </div> */}
            <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '2%' }}>
                <Grid container alignItems="center" spacing={3}>
                    {/* Dropdown on the left */}
                    <Grid item xs={3} md={2.5} >
                        {haveMultiEntity && <FormControl variant="outlined" fullWidth>
                            <InputLabel id="entity-select-label">Select Entity</InputLabel>
                            <Select
                                style={{ height: '40px' }}
                                labelId="entity-select-label"
                                value={selectedEntity}
                                onChange={(event) => setSelectedEntity(event.target.value)}
                                label="Select Entity"
                            >
                                {entityData.map((entity) => (
                                    <MenuItem key={entity.business_entity_id} value={entity.business_entity_id}>
                                        {entity.entity_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>}
                    </Grid>

                    <Grid item xs={12} md={5.5} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Typography
                            variant="h6"
                            sx={{
                                textAlign: 'center',
                                letterSpacing: '0.08rem',
                                fontFamily: `'Montserrat', sans-serif`,
                                textTransform: 'uppercase',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                padding: '4px 0',
                                transition: 'all 0.3s ease',
                                '&:hover .icon-bg': {
                                    transform: 'scale(1.1)',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                                }
                            }}
                        >
                            <span style={{ fontWeight: 'bold', color: '#1D3557' }}>C2C</span>
                            <span style={{ fontWeight: 'normal', color: "#212121" }}>Analytics</span>

                            <Box
                                className="icon-md"
                                sx={{
                                    marginBottom: 1
                                }}
                            >
                                <ScatterPlotIcon
                                    style={{
                                        color: 'black',
                                        fontSize: '1.8rem',
                                    }}
                                />
                            </Box>
                        </Typography>


                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontFamily: `'Montserrat', sans-serif`,
                                color: '#555555',
                                fontWeight: 500,
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                letterSpacing: '0.05rem',
                                marginRight: 4
                            }}
                        >
                            Report Date: {displyAsOFDate ? moment(displyAsOFDate).format('DD-MM-YYYY') : 'Not Set'}
                        </Typography>

                    </Grid>

                    {/* Buttons on the right */}
                    <Grid item xs={6} md={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Tooltip title="Back" arrow>

                            <IconButton
                                // color='warning'
                                onClick={() => history.goBack()}
                                sx={{
                                    borderRadius: '50%',
                                    padding: '8px',
                                    color: '#263238',
                                    fontSize: '24px',
                                    marginRight: '15px',
                                    backgroundColor: '#ffffff',
                                    '&:hover': {
                                        backgroundColor: '#455a64',
                                        color: '#ffffff',
                                    },
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                    transition: 'background-color 0.3s ease',
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>

                        </Tooltip>

                        <Tooltip title="Date Filter" arrow>

                            <IconButton
                                color='primary'
                                onClick={handlePopoverOpen}
                                sx={{
                                    borderRadius: '50%',  // Round button
                                    padding: '8px',
                                    fontSize: '30px',
                                    marginRight: '15px',
                                    backgroundColor: Boolean(anchorEl) ? '#ffffff' : '#2196f3',
                                    color: Boolean(anchorEl) ? '#2196f3' : '#ffffff',
                                    '&:hover': {
                                        backgroundColor: '#ffffff',
                                        color: '#2196f3',
                                    },
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                    transition: 'background-color 0.3s ease',
                                }}
                            >
                                <CalendarMonthIcon />
                            </IconButton>

                        </Tooltip>

                        <Tooltip title="Export" arrow>

                            <IconButton
                                color='success'
                                onClick={() => { if (!exportButtonLaoding) handleExportExcel(); }}
                                sx={{
                                    borderRadius: '50%',  // Round button
                                    padding: '8px',
                                    fontSize: '24px',
                                    marginRight: '15px',
                                    backgroundColor: '#ffffff',
                                    '&:hover': {
                                        backgroundColor: '#ccff90',
                                        color: '#000000',
                                    },
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                    transition: 'background-color 0.3s ease',
                                }}
                            >
                                {exportButtonLaoding ? <CircularProgress sx={{ color: '#1976d2', size: 20 }} size={20} />
                                    : <img
                                        style={{ height: 24, width: 24, objectFit: 'contain' }}
                                        src='https://img.icons8.com/?size=48&id=117561&format=png'
                                        alt="Export Icon"
                                    />}
                            </IconButton>

                        </Tooltip>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handlePopoverClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <Box sx={{ padding: 3, minWidth: 300 }}>
                                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                                    Select Date Filter
                                </Typography>

                                {/* As of Date Option */}
                                <Box sx={{ mb: 3 }}>
                                    <Box
                                        onClick={() => handleDateFilterChange('as_of_date')}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            padding: '8px',
                                            borderRadius: '8px',
                                            backgroundColor: selectedDateFilter === 'as_of_date' ? '#e3f2fd' : 'transparent',
                                            '&:hover': {
                                                backgroundColor: '#f5f5f5'
                                            }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: '50%',
                                                border: '2px solid #2196f3',
                                                marginRight: 2,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {selectedDateFilter === 'as_of_date' && (
                                                <Box
                                                    sx={{
                                                        width: 12,
                                                        height: 12,
                                                        borderRadius: '50%',
                                                        backgroundColor: '#2196f3'
                                                    }}
                                                />
                                            )}
                                        </Box>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontWeight: selectedDateFilter === 'as_of_date' ? 600 : 400,
                                                color: selectedDateFilter === 'as_of_date' ? '#2196f3' : '#666'
                                            }}
                                        >
                                            As of Date
                                        </Typography>
                                    </Box>
                                    {selectedDateFilter === 'as_of_date' && (
                                        <Box sx={{ mt: 2, ml: 4 }}>
                                            <ValidatorForm>
                                                <DatePicker
                                                    placeholder="Select Date"
                                                    errorMessages={["This field is required"]}
                                                    validators={["required"]}
                                                    value={displyAsOFDate ?? ""}
                                                    onChange={(v) => onDateChnageHandler(v)}
                                                />
                                            </ValidatorForm>
                                        </Box>
                                    )}
                                </Box>

                                {/* Custom Date Option */}
                                <Box>
                                    <Box
                                        onClick={() => handleDateFilterChange('custom_date')}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            padding: '8px',
                                            borderRadius: '8px',
                                            backgroundColor: selectedDateFilter === 'custom_date' ? '#e3f2fd' : 'transparent',
                                            '&:hover': {
                                                backgroundColor: '#f5f5f5'
                                            }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: '50%',
                                                border: '2px solid #2196f3',
                                                marginRight: 2,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {selectedDateFilter === 'custom_date' && (
                                                <Box
                                                    sx={{
                                                        width: 12,
                                                        height: 12,
                                                        borderRadius: '50%',
                                                        backgroundColor: '#2196f3'
                                                    }}
                                                />
                                            )}
                                        </Box>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontWeight: selectedDateFilter === 'custom_date' ? 600 : 400,
                                                color: selectedDateFilter === 'custom_date' ? '#2196f3' : '#666'
                                            }}
                                        >
                                            Custom Date Range
                                        </Typography>
                                    </Box>
                                    {selectedDateFilter === 'custom_date' && (
                                        <Box sx={{ mt: 2, ml: 4 }}>
                                            <ValidatorForm>
                                                <Box sx={{ mb: 2 }}>
                                                    <Typography variant="caption" sx={{ mb: 0.5, display: 'block', color: '#666' }}>
                                                        From Date
                                                    </Typography>
                                                    <DatePicker
                                                        placeholder="From Date"
                                                        errorMessages={["This field is required"]}
                                                        validators={["required"]}
                                                        value={displayCustomFromDate ?? ""}
                                                        onChange={(v) => onCustomFromDateChange(v)}
                                                    />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" sx={{ mb: 0.5, display: 'block', color: '#666' }}>
                                                        To Date
                                                    </Typography>
                                                    <DatePicker
                                                        placeholder="To Date"
                                                        errorMessages={["This field is required"]}
                                                        validators={["required"]}
                                                        value={displayCustomToDate ?? ""}
                                                        onChange={(v) => onCustomToDateChange(v)}
                                                    />
                                                </Box>
                                            </ValidatorForm>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Popover>

                    </Grid>
                </Grid>
            </Box>

            {!loading ?
                c2cDashboardCardsData && Object.keys(c2cDashboardCardsData).length > 0 ? (
                    <Grid container lg={12} spacing={2} >
                        {renderC2CAnalyticsCards()}
                        {renderAdditionalCards()}
                        <Grid item xs={12} md={6} mb={1}>
                            <ResponsiveContainer style={{ marginTop: '1%', flexGrow: 1 }} width="100%" height="100" id="chart-container-c2c-sales">
                                {
                                    overDueDataSales.length > 0 &&
                                    <PieChart
                                        graphData={overDueDataSales} id="myPieChart"
                                        title="Receivable Overdue Ageing Summary"
                                    />
                                }
                            </ResponsiveContainer>
                        </Grid>
                        <Grid item xs={12} md={6} mb={1}>
                            <ResponsiveContainer style={{ marginTop: '1%', flexGrow: 1 }} width="100%" height="100" id="chart-container-c2c-sales">
                                {
                                    overDueDataPurchses.length > 0 &&
                                    <PieChart
                                        graphData={overDueDataPurchses} id="purchases"
                                        title="Payables Overdue Ageing Summary"
                                    />
                                }
                            </ResponsiveContainer>
                        </Grid>
                        {renderGstr1AmountNotCollectedReport()}
                        {renderGstUsageStackedChart()}
                        {renderTdsAmountNotReflectedReport()}
                    </Grid>
                ) : renderEmptyState()
                :
                <React.Fragment>
                    <svg width={0} height={0}>
                        <defs>
                            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#e01cd5" />
                                <stop offset="100%" stopColor="#1CB5E0" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <Grid container justifyContent="center" alignItems="center" style={{ height: '45vh' }}>
                        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={50} />
                    </Grid>
                </React.Fragment>
            }
        </div>
    )
}

export default C2CReport;
